import React from 'react';
import Form from 'react-jsonschema-form-carbon';
import { ErrorTemplate } from './Templates';

import { Button } from 'carbon-components-react';
import { Add16, Delete16 } from '@carbon/icons-react';

import {
  CustomTextInput,
  CustomFileHashInput,
  CustomSelect,
  CustomSubformTextInput,
  CustomSubformNumericInput,
  CustomSubformSelectInput,
  CustomNumericInput,
  CustomObjectSubform,
  CustomDateInput,
  BooleanFormControl
} from './CustomComponents';
import { TextWithTagsFormControl } from '../Builder/FormCarbon/FormControls';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  formItemArray: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 24,
    marginLeft: 40,
    '& .array-item': {
      display: 'flex',
      alignItems: 'flex-start',
      flexWrap: 'wrap'
    }
  },
  title: {
    marginTop: 18,
    marginBottom: 12
  },
  subFormItems: {
    overflowY: 'auto',
    maxHeight: 160
  },
  formItemArrayRow: {
    display: 'flex',
    border: 'none',
    '& div': {
      display: 'flex',
      flex: 2
    },
    '& fieldset': {
      '& div': {
        flex: 1,
        paddingRight: 24
      },
      '& .field-array': {
        flex: 1,
        paddingRight: 24,
        width: 300,
        minWidth: 250,
        maxWidth: 300
      }
    }
  }
});

const FormTransaction = (props) => {
  const {
    onSubmit,
    formData,
    schema,
    uiSchema,
    formRef,
    submitFormButton
  } = props;

  const ArrayFieldTemplate = (props) => {
    const classes = useStyles();
    return (
      <div className={classes.formItemArray}>
        <div className={classes.title}>
          {props.items.length ? props.schema.title : ''}
        </div>
        <div className={classes.subFormItems}>
          {props.items &&
            props.items.map((element) => {
              return (
                <div key={element.key} className={classes.formItemArrayRow}>
                  {element.children}

                  <Button
                    className='bx--btn bx--btn--ghost bx--btn--sm remove-button'
                    onClick={element.onDropIndexClick(element.index)}
                  >
                    {!element.readonly && (
                      <Delete16 aria-label='Delete' />
                    )}
                  </Button>
                </div>
              );
            })}
        </div>

        {props.canAdd && (
          <div className='row'>
            <p className='col-xs-3 col-xs-offset-9 text-right'>
              <Button
                className='bx--btn bx--btn--ghost bx--btn--sm add-item-button'
                onClick={props.onAddClick}
                renderIcon={Add16}
              >
                Añadir asset
              </Button>
            </p>
          </div>
        )}
      </div>
    );
  };

  const fields = {
    customText: CustomTextInput,
    customSelect: CustomSelect,
    customSubformTextInput: CustomSubformTextInput,
    customFileHashInput: CustomFileHashInput,
    customNumeric: CustomNumericInput,
    customSubformSelectInput: CustomSubformSelectInput,
    customSubformNumericInput: CustomSubformNumericInput,
    customObjectSubform: CustomObjectSubform,
    DateInput: CustomDateInput,
    Checkbox: BooleanFormControl,
    TextInputWithTags: TextWithTagsFormControl
  };

  return (
    <Form
      ref={formRef}
      className='form-transactions'
      schema={schema}
      uiSchema={uiSchema}
      fields={fields}
      ArrayFieldTemplate={ArrayFieldTemplate}
      ErrorList={ErrorTemplate}
      autoComplete='off'
      onSubmit={(e) => onSubmit(e.formData)}
      formData={formData}
    >
      <button
        ref={submitFormButton}
        type='submit'
        style={{ display: 'none' }}
      />
    </Form>
  );
};

export default FormTransaction;
